import React, { useEffect, useState } from "react";
import { SettingContent } from "../styled/setting";

import Options from "./optionGroup/options";
import AddOption from "./optionGroup/addOption";
import EditOption from "./optionGroup/editOption";
import axios from "axios";
import { defaultOption } from "../function/store";
import LinkProducts from "./optionGroup/linkProducts";

const OptionGroup = ({
  selectCompany,
  openModal,
  closeModal,
  optionGroup,
  getOptions,
  products,
}) => {
  const [active, setActive] = useState(0);
  const [selected, setSelected] = useState(defaultOption);
  const [context, setContext] = useState({ type: "", id: null });
  const [isOpen, setIsOpen] = useState(false);

  const transformValue = (active ? 1 : 0) * -100;

  const changeTab = (idx, item = null) => {
    setActive(idx);
    setSelected(item);
  };

  const toggleModal = (item = null) => {
    if (item) {
      setSelected(item);
      setIsOpen(true);
    } else {
      setSelected(null);
      setIsOpen(false);
    }
  };

  return (
    <SettingContent>
      {isOpen && (
        <LinkProducts
          toggleModal={toggleModal}
          products={products}
          selected={selected}
          openModal={openModal}
          closeModal={closeModal}
          selectCompany={selectCompany}
          getOptions={getOptions}
        />
      )}
      <div className="slideWrapper">
        <Options
          transformValue={transformValue}
          data={optionGroup}
          selectCompany={selectCompany}
          changeTab={changeTab}
          context={context}
          setContext={setContext}
          openModal={openModal}
          closeModal={closeModal}
          getOptions={getOptions}
          toggleModal={toggleModal}
        />
        <div className="slideContent" style={{ transform: `translateX(${transformValue}%)` }}>
          {
            [
              <AddOption
                changeTab={changeTab}
                selectCompany={selectCompany}
                openModal={openModal}
                closeModal={closeModal}
                getOptions={getOptions}
              />,
              <EditOption
                changeTab={changeTab}
                selected={selected}
                selectCompany={selectCompany}
                openModal={openModal}
                closeModal={closeModal}
                getOptions={getOptions}
              />,
            ][active ? active - 1 : active]
          }
        </div>
      </div>
    </SettingContent>
  );
};

export default OptionGroup;
